import React, { useRef, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { assetUrl } from "fusion-core";
import { Helmet } from "fusion-plugin-react-helmet-async";
import Footer from "../../../shared/components/footer";
import Navbar from "../../../shared/components/navbar";
import Loader from "../../../shared/components/Loader";
import useAppStateStore from "../../../shared/store/AppStateStore";

const TbPclAgreementPage = () => {
  const [searchParams] = useSearchParams();
  const rawMessage = searchParams.get("PclResponse");
  const iframeRef = useRef(null);
  const formRef = useRef(null);
  const mainCss = assetUrl("../../../styles/main.css");

  const [pclResponse, setPclResponse] = useState(null);

  useEffect(() => {
    const storedPclData = localStorage.getItem("pclAgreementData");
    if (storedPclData) {
      const pclData = JSON.parse(storedPclData);
      setPclResponse(pclData);
    }
  }, []);

  useEffect(() => {
    const resizeIframe = () => {
      const iframe = iframeRef.current;
      if (iframe && iframe.contentWindow) {
        iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
      }
    };

    const iframe = iframeRef.current;

    if (iframe) {
      iframe.addEventListener("load", resizeIframe);
      window.addEventListener("resize", resizeIframe);

      // Optionally observe iframe content for changes
      const observer = new MutationObserver(resizeIframe);
      if (iframe.contentDocument) {
        observer.observe(iframe.contentDocument.body, {
          childList: true,
          subtree: true,
        });
      }

      return () => {
        iframe.removeEventListener("load", resizeIframe);
        window.removeEventListener("resize", resizeIframe);
        observer.disconnect();
      };
    }
  }, []);

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  const allowPCLFormEdit = pclResponse?.AllowPCLFormEdit;
  const cancelUrl = pclResponse?.__CANCELURL;
  const errorUrl = pclResponse?.__ERRORURL;
  const FITK = pclResponse?.__FITK;
  const reqId = pclResponse?.__REQID;

  useEffect(() => {
    if (!allowPCLFormEdit) {
      handleSubmit();
    }
  }, [allowPCLFormEdit, formRef.current, pclResponse]);

  return (
    <>
      <Navbar />
      <div className="tw-relative tw-min-h-[calc(100vh-200px)] tw-py-[5%] max-[480px]:tw-min-h-[calc(100vh-280px)] tw-bg-dis-page tw-text-dis-text-2 [&_h1]:tw-text-dis-navy [&_h2]:tw-text-dis-navy [&_h3]:tw-text-dis-navy [&_p]:tw-text-dis-text-2 [&_label]:tw-text-dis-text [&_li]:tw-text-dis-text-2 [&_a]:tw-text-dis-deep-blue">
        <Helmet>
          <link rel="stylesheet" href={mainCss} />
        </Helmet>
        {!pclResponse ? (
          <Loader text={"Loading... "} />
        ) : (
          <div>
            <h1>PCL Agreement Page</h1>

            {allowPCLFormEdit && (
              <form
                ref={formRef}
                target="FITSIFrame"
                id="frmSendForm"
                method="post"
                action="https://ebt-digitised.test.pcl.co.uk/Content"
              >
                <label>REQID</label>
                <input
                  type="text"
                  name="__REQID"
                  defaultValue=""
                  value={reqId}
                />

                <label>FITK</label>
                <input type="text" name="__FITK" defaultValue="" value={FITK} />

                <label>Cancel URL</label>
                <input
                  type="text"
                  name="__CANCELURL"
                  defaultValue=""
                  value={cancelUrl}
                />

                <label>Error URL</label>
                <input
                  type="text"
                  name="__ERRORURL"
                  defaultValue=""
                  value={errorUrl}
                />

                <button type="button" name="myButton" onClick={handleSubmit}>
                  Submit
                </button>
              </form>
            )}

            {!allowPCLFormEdit && (
              <form
                ref={formRef}
                target="FITSIFrame"
                id="frmSendForm"
                method="post"
                action="https://ebt-digitised.test.pcl.co.uk/Content"
              >
                <input type="hidden" name="__REQID" value={reqId} />
                <input type="hidden" name="__FITK" value={FITK} />
                <input type="hidden" name="__CANCELURL" value={cancelUrl} />
                <input type="hidden" name="__ERRORURL" value={errorUrl} />
              </form>
            )}

            <div className="container">
              <iframe
                ref={iframeRef}
                id="ifrmFitsIframe"
                name="FITSIFrame"
                className="tw-h-[70vh] tw-w-full tw-max-w-full tw-border-0"
                sandbox="allow-scripts allow-forms allow-same-origin"
              ></iframe>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default TbPclAgreementPage;
